import ModalButtons from "../../ui-components/ModalButtons/ModalButtons";
import usePost from "../../../hooks/usePost";
import {useEffect} from "react";

const DeleteMember = ({user, closeModal, updateMembers}) => {

    const {sending, returnPostData, postData} = usePost()

    function deleteMemberHandler(){
        const data = {
            memberId: user.id
        }
        postData(data, '/api/members/delete/', 1000)
    }

    useEffect(() => {
        if(returnPostData){
            updateMembers(user.id)
            closeModal()
        }

    }, [returnPostData, closeModal, updateMembers, user.id])

    return(
        <>
            <h1>Delete Member</h1>
            <br />
            <div className='ReturnMsg ReturnMsgError'>
                Are you sure you want to delete this member? Any courses they've taken and grades they've been given will be retained but all other account information will be deleted from the system.
            </div>
            <p>Name: {user.name}</p>
            <p>Email: {user.email}</p>

            <ModalButtons
                button1Text={'Delete Account'}
                button1Function={() => deleteMemberHandler()}
                closeModal={closeModal}
            />
            {sending && <div className={'sending'} />}
        </>
    )
}

export default DeleteMember
